import { Components, Theme } from '@mui/material/styles';

export const flowDialogContent: Components<Theme>['MuiDialogContent'] = {
  defaultProps: {
    dividers: false,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      padding: '24px 40px',
      margin: '0',
      [theme.breakpoints.down('md')]: {
        paddingLeft: '24px',
        paddingRight: '24px',
      },
    }),
    dividers: ({ theme }) => ({
      border: 'none',
      '& ~ .MuiDialogActions-root': {
        borderTop: `1px solid ${theme.palette.surface.secondary}`,
      },
    }),
  },
};
